import type { SelectedFilters } from "../types";

export const getURLParamsFromFilters = (filters: SelectedFilters): URLSearchParams => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, values]) => {
        if (Array.isArray(values)) {
            for (const value of values) {
                if (value !== null) {
                    params.append(key, value);
                }
            }
        } else if (values !== null) {
            params.append(key, values);
        }
    });
    return params;
};
